<template>
  <b-modal
    ref="modal"
    id="tfa-setup"
    centered
    hide-header
    hide-footer
    @hidden="done"
  >
    <template v-if="step === 1">
      <h2>Enable 2FA</h2>
      <p>
        Enabling 2FA will add a second layer of security to your account to
        prevent unauthorized access.
      </p>
      <div class="d-flex mt-4 text-right">
        <b-button
          variant="secondary"
          class="px-4 mr-auto"
          @click="$refs.modal.hide()"
        >
          Cancel
        </b-button>
        <b-button variant="primary" class="px-4" @click="step1">
          Continue
        </b-button>
      </div>
    </template>

    <template v-else-if="step === 2">
      <h2>Set up your authenticator app</h2>
      <div class="mb-4">
        To enable 2FA for your Nanome account, you will need an authenticator
        app (like Google Authenticator or Authy). Once you have installed the
        app, use one of the methods below to continue the process.
      </div>
      <div class="text-center">
        <div>Scan the QR code below using your authenticator app</div>
        <img :src="qr" :alt="secret" />
        <div>Or manually enter the code below</div>
        <div class="font-weight-bold font-lg">{{ secret }}</div>
      </div>
      <div class="d-flex mt-4 text-right">
        <b-button variant="secondary" class="px-4 mr-auto" @click="step = 1">
          Back
        </b-button>
        <b-button variant="primary" class="px-4" @click="step2">
          Continue
        </b-button>
      </div>
    </template>

    <template v-else-if="step === 3">
      <h2>Confirm 2FA code</h2>
      <div>
        Enter the six-digit code you see in the authenticator app for Nanome.
      </div>
      <NanInput
        ref="input"
        v-model="code"
        prependIcon="icon-key"
        placeholder="2FA Code"
        aria-label="2FA Code"
        class="mt-4 w-50 mx-auto"
        @keyup.enter="step3"
      />
      <div v-if="error" class="small text-danger text-center">
        invalid code, try again
      </div>
      <div class="d-flex mt-4 text-right">
        <b-button variant="secondary" class="px-4 mr-auto" @click="step = 2">
          Back
        </b-button>
        <b-button
          :disabled="!code"
          variant="primary"
          class="px-4"
          @click="step3"
        >
          Continue
        </b-button>
      </div>
    </template>

    <template v-else-if="step === 4">
      <RecoveryCodes :codes="codes" @close="$refs.modal.hide()" />
    </template>
  </b-modal>
</template>

<script>
import API from "@/api";
import RecoveryCodes from "./RecoveryCodes";

export default {
  components: { RecoveryCodes },

  data: () => ({
    step: 1,
    code: "",
    qr: "",
    secret: "",
    codes: [],
    error: false,
    complete: false
  }),

  methods: {
    async step1() {
      const res = await API.enable2FA();
      if (!res.success) return;
      this.qr = res.results.qr;
      this.secret = res.results.secret;
      this.step = 2;
    },

    async step2() {
      this.step = 3;
      await this.$nextTick();
      this.$refs.input.focus();
    },

    async step3() {
      const res = await API.confirm2FA(this.code);
      if (!res.success) {
        this.error = true;
        return;
      }
      this.codes = res.results.recovery_codes;
      this.complete = true;
      this.step = 4;
    },

    done() {
      if (this.complete) {
        location.reload();
      }
      this.reset();
    },

    reset() {
      this.step = 1;
      this.code = "";
      this.qr = "";
      this.secret = "";
      this.codes = [];
      this.error = false;
      this.complete = false;
    }
  }
};
</script>
